// src/AchievementManager.js

export const ACHIEVEMENTS = [
  {
    id: 'COCA_GUARDIA',
    name: '🥤 La Coca de la Guardia',
    desc: 'Completar 3 guardias el mismo día.',
    check: (session, stats) => stats.dailyGuards >= 3,
    reward: { type: 'xp_bonus', value: 0.05 }
  },
  {
    id: 'ELOTE_CHILE',
    name: '🌽 El Elote con Chile',
    desc: 'Racha de 5 respuestas correctas en una sola sesión.',
    check: (session, stats) => {
      const results = session.results || [];
      let maxStreak = 0;
      let currentStreak = 0;
      for (const r of results) {
        if (r.result === 'correct') {
          currentStreak++;
          if (currentStreak > maxStreak) maxStreak = currentStreak;
        } else {
          currentStreak = 0;
        }
      }
      return maxStreak >= 5;
    },
    reward: { type: 'xp_bonus', value: 0.02 }
  },
  {
    id: 'CAFE_CARGADO',
    name: '☕ Café Bien Cargado',
    desc: 'Completar una guardia con < 10s promedio por decisión.',
    check: (session, stats) => {
      const results = session.results || [];
      if (results.length === 0) return false;
      const avg = results.reduce((acc, r) => acc + r.timeElapsed, 0) / results.length;
      return avg < 10000;
    },
    reward: { type: 'stamina_max', value: 1 }
  },
  {
    id: 'ESTETO_NUEVO',
    name: '🩺 Esteto Nuevo',
    desc: 'Completar el caso de STEMI (HARD) sin errores críticos.',
    check: (session, stats) => {
      const isStemi = session.results?.some(r => r.node_id?.toLowerCase().includes('iam') || r.node_id?.toLowerCase().includes('stemi'));
      const hasErrors = session.results?.some(r => r.result !== 'correct');
      return isStemi && !hasErrors;
    },
    reward: { type: 'credits', value: 500 }
  },
  {
    id: 'TENNIS_COMODOS',
    name: '👟 Tennis de Especialidad',
    desc: 'Total de 10 casos sin fallos letales (histórico).',
    check: (session, stats) => stats.lifetimeCleanCases >= 10,
    reward: { type: 'burnout_resist', value: 0.1 }
  },
  {
    id: 'COLCHON_MI',
    name: '🛏️ Colchón para la MI',
    desc: 'Mantener la estabilidad del paciente al 100% al finalizar 3 guardias.',
    check: (session, stats) => stats.perfectStabilityGuards >= 3,
    reward: { type: 'xp', value: 1000 }
  }
];

export class AchievementManager {
  static ACHIEVEMENTS = ACHIEVEMENTS;

  static checkNewAchievements(session, economy) {
    const s = economy.state;
    const stats = {
      dailyGuards: s.dailyGuards || 0,
      lifetimeCleanCases: s.lifetimeCleanCases || 0,
      perfectStabilityGuards: s.perfectStabilityGuards || 0
    };

    const newlyUnlocked = [];

    ACHIEVEMENTS.forEach(ach => {
      if (s.unlockedAchievements?.includes(ach.id)) return;

      if (ach.check(session, stats)) {
        newlyUnlocked.push(ach);
      }
    });

    return newlyUnlocked;
  }
}
